<template>
  <div class="userSelect">
    <el-select
      v-model="value"
      filterable
      remote
      clearable
      reserve-keyword
      :placeholder="placeholder"
      :remote-method="remoteMethod"
      :loading="userLoading"
      size="small"
      @change="updateData"
      @focus="closeReadOnly"
      @blur="closeReadOnly"
    >
      <el-option
        v-for="item in usersOptions"
        :key="item.account"
        :label="item.psnName"
        :value="`${item.account}-${item.psnName}`"
      >
        <span style="float: left">{{ item.psnName }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{
          item.account
        }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import * as tenantUserApi from '../../api/userApi'
export default {
  props: {
    valueInput: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      usersOptions: [],
      userLoading: false,
      value: this.valueInput,
    }
  },
  mounted() {
    this.closeReadOnly()
  },
  methods: {
    remoteMethod(query) {
      // 搜索联系人
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (query !== '') {
          this.userLoading = true
          tenantUserApi.queryUserByKeyword({ keyword: query }).then((res) => {
            this.userLoading = false
            if (res.code != '0000') {
              this.$message({
                type: 'error',
                message: res.msg,
              })
              return
            } else {
              this.usersOptions = res.data || []
            }
          })
        } else {
          this.options = []
        }
      }, 300)
    },
    updateData() {
      this.$emit('update:valueInput', this.value)
      this.$emit('updateData')
    },
    closeReadOnly() {
      // 去除el-select默认的readOnly，否则移动端下拉框出不来
      Array.from(document.getElementsByClassName('el-select')).forEach((item) => {
        item.children[0].children[0].removeAttribute('readOnly')
        item.children[0].children[0].onblur = function () {
          let _this = this
          _this.removeAttribute('readOnly')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
